import React, { useEffect, useState } from "react";
import {
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import { CircularProgress, Typography, Box } from "@mui/material";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const PieChart = ({ userId }) => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSocialMediaCounts = async () => {
    try {
      if (!userId) {
        setError("User details are missing. Unable to fetch pro_id.");
        return;
      }

      const response = await axios.get(
        `${
          import.meta.env.VITE_BACKEND_URL
        }/dash/dashboard-insights/social-media-count?user_id=${userId}`
      );

      const data = response.data;

      if (data.success) {
        // Map API response to chart data format
        const formattedData = [
          { name: "Instagram Posts", value: data.data.instagramPost },
          { name: "Instagram Reels", value: data.data.instagramReel },
          { name: "YouTube Shorts", value: data.data.youtubeShort },
          { name: "Spotify Podcasts", value: data.data.spotifyPodcast },
        ];

        setChartData(formattedData);
      } else {
        setError(data.message || "Failed to fetch social media insights.");
      }
    } catch (error) {
      console.error("Error fetching social media counts:", error);
      setError("An error occurred while fetching social media data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialMediaCounts();
  }, [userId]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={300}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={300}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (chartData.every((data) => data.value === 0)) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={300}
      >
        <Typography>No social media activity available.</Typography>
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RechartsPieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </RechartsPieChart>
    </ResponsiveContainer>
  );
};

export default PieChart;
